import angular from 'angular'
import moment from 'moment-timezone'
import './raffles.service'
import './view/raffles.view.controller'
angular
  .module('pub.raffles', ['pub.raffles.service', 'pub.raffles.view'])
  .controller('RafflesCtrl', RafflesCtrl)

/** @ngInject */
function RafflesCtrl($scope, $q, $state, $stateParams, RaffleService, TopPrizeService) {
  var vm = this

  vm.items = []
  vm.perPage = 25
  vm.pathImgThumb = ''
  vm.topPrizeID = $stateParams.topPrizeId
  vm.channelId = $stateParams.parentId
  vm.isOpen1 = false
  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen1 = true
  }

  TopPrizeService.get(vm.topPrizeID).then(function (result) {
    vm.topPrize = result.results
  })

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()
  load(1)

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    RaffleService.list(vm.topPrizeID, vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      var promise = []
      for (var i = 0; i < result.results.length; i++) {
        promise.push(RaffleService.getWinners(result.results[i].id, 0, 1))
      }

      vm.items = result.results

      $q.all(promise).then(function (result) {
        for (var i = 0; i < result.length; i++) {
          for (var j = 0; j < vm.items.length; j++) {
            if (vm.items[j].id === result[i].results[0]['id-raf']) {
              vm.items[j].winner = result[i].results
              break
            }
          }
        }
      })
    })
  }

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.view = function (item) {
    $state.go('pub.channels.top_prizes.raffles.view', {
      id: item.id,
      parentId: vm.channelId,
      topPrizeId: vm.topPrizeID,
    })
  }

  vm.add = function () {
    vm.app = {
      id: 0,
      'id-tp': vm.channelId,
      cd: '',
      'ts-raf': '',
    }
    vm.date1 = ''
    $('#myModalAdd').modal('show')
  }

  vm.edit = function (item) {
    vm.app = angular.copy(item)
    delete vm.app.ts
    delete vm.app['ts-m']
    vm.date1 = new Date(parseInt(vm.app['ts-raf'] / 1000))

    $('#myModalAdd').modal('show')
  }

  vm.create = function () {
    vm.app.cd = parseInt(vm.app.cd)
    vm.app['id-tp'] = parseInt(vm.topPrizeID)
    if (vm.date1 !== undefined && vm.date1 !== '' && vm.date1 !== null) {
      if (isDate(vm.date1)) {
        var date = parseInt(new Date(new Date(vm.date1).setSeconds(0)).getTime() * 1000)
        vm.app['ts-raf'] = date
      }
    } else {
      vm.app['ts-raf'] = null
    }

    RaffleService.save(vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        load(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.update = function () {
    vm.app.cd = parseInt(vm.app.cd)
    vm.app['id-tp'] = parseInt(vm.topPrizeID)

    if (vm.date1 !== undefined && vm.date1 !== '' && vm.date1 !== null) {
      if (isDate(vm.date1)) {
        var date = parseInt(new Date(new Date(vm.date1).setSeconds(0)).getTime() * 1000)
        vm.app['ts-raf'] = date
      }
    } else {
      vm.app['ts-raf'] = null
    }

    RaffleService.update(vm.app.id, vm.app).then(
      function () {
        $('#myModalAdd').modal('hide')
        load(1)
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          RaffleService.remove(item.id).then(
            function () {
              $('#myModalAdd').modal('hide')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  var watch1 = $scope.$watch('vm.date1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
  })

  vm.back = function () {
    $state.go('pub.channels.top_prizes', { parentId: $stateParams.parentId })
  }

  vm.currentItem = null
  vm.openModal = function (item) {
    vm.currentItem = item
    if (!vm.currentItem.sh) {
      vm.currentItem.sh = []
    }
    $('#myModalShinies').modal('show')
  }

  vm.openModalWinners = function (item) {
    $('#myModalWinners').modal('show')
    RaffleService.getWinners(item.id).then(function (result) {
      vm.winners = result.results
    })
  }

  vm.searchShinies = function () {
    if (vm.searchModal === undefined || vm.searchModal === '') {
      return
    }

    RaffleService.searchShinies(vm.searchModal, vm.channelId, 0, 100).then(function (result) {
      let res = result.results
      res = res.filter(function (item) {
        return (
          vm.currentItem.sh.findIndex(function (shiny) {
            return shiny.id === item.id
          }) === -1
        )
      })
      vm.new_shinies = res
    })
  }

  vm.addShiny = function (item) {
    RaffleService.addShiny(vm.currentItem.id, item.id).then(
      function () {
        vm.currentItem.sh.push(item)
        vm.searchShinies()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteShiny = function (item) {
    RaffleService.deleteShiny(vm.currentItem.id, item.id).then(
      function () {
        vm.currentItem.sh = vm.currentItem.sh.filter(function (shiny) {
          return shiny.id !== item.id
        })
        vm.searchShinies()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }
}
